<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-form ref="poform" id="poform" v-model="valid" lazy-validation>
                <v-toolbar flat>
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-spacer />
                    <v-btn color="grey" dark class="mb-2 mr-2" @click="backToPO" small>
                        <v-icon small>mdi-arrow-left</v-icon>
                        Back
                    </v-btn>
                </v-toolbar>
                <div class="mt-3">
                    <v-row class="compact-form my-2 mx-1">
                        <v-col cols="2">Outlet</v-col>
                        <v-col cols="4">
                            <div v-if="isReadonly" class="readonly-field">{{ outlet.name }}</div>
                            <v-text-field v-else hide-details="auto" dense outlined readonly filled v-model="outlet.name" />
                        </v-col>
                        <v-col cols="2">Delivery Date</v-col>
                        <v-col cols="4">
                            <div v-if="isReadonly" class="readonly-field">{{ formattedSelectedDateRange }}</div>
                            <v-menu v-else v-model="menuDate"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto">
                                <template v-slot:activator="{ on, attrs}">
                                    <v-text-field dense outlined readonly hide-details="auto"
                                        v-model="formattedSelectedDateRange"
                                        v-bind="attrs"
                                        v-on="on" />
                                </template>
                                <v-date-picker v-model="selectedDate" @input="handleDateChange" />
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row class="compact-form my-2 mx-1 mb-0 pb-0">
                        <v-col cols="2">Delivery Schedules</v-col>
                        <v-col cols="4">
                            <div v-if="isReadonly" class="readonly-field">{{ deliveryScheduleDays }}</div>
                            <v-text-field v-else hide-details="auto" dense outlined readonly filled v-model="deliveryScheduleDays" />
                        </v-col>
                        <v-col cols="2">Variant Bottle</v-col>
                        <v-col cols="4">
                            <div v-if="isReadonly" class="readonly-field">{{ selectedBotolLabel }}</div>
                            <v-select v-else outlined dense hide-details="auto" :items="filteredBotols" item-value="code" item-text="description" v-model="filterBotol" @change="onBotolChange" />
                        </v-col>
                    </v-row>
                    <v-row class="compact-form my-2 mx-1">
                        <v-col>
                            <v-card outlined>
                                <template>
                                <v-card-actions class="pr-4 mt-1 mx-5">
                                    <v-spacer />
                                    <v-btn v-if="!isReadonly" @click="showDialog = true">Add PO</v-btn>

                                    <AdditionalAddDialog
                                        v-if="!isReadonly"
                                        :dialog.sync="showDialog"
                                        :defaultDays="defaultDays"
                                        :weekDates="weekDates"
                                        :filteredPOProducts="filteredPOProducts"
                                        :outletcode="outlet.code"
                                        @save="handleSaveAdditional"
                                    />
                                </v-card-actions>
                                </template>

                                <v-simple-table fixed-header fixed-footer height="600px">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="header-cell" colspan="2">Target Sales (Detail Planning)</th>

                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ target_sales_sun }}</div>
                                                    <v-text-field v-else v-model="target_sales_sun" class="text-center-input disable2-input" type="number" readonly solo hide-details @wheel="$event.target.blur()" min="0"/>
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ target_sales_mon }}</div>
                                                    <v-text-field v-else v-model="target_sales_mon" type="number" readonly class="text-center-input disable2-input" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ target_sales_tue }}</div>
                                                    <v-text-field v-else v-model="target_sales_tue" type="number" readonly class="text-center-input disable2-input" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ target_sales_wed }}</div>
                                                    <v-text-field v-else v-model="target_sales_wed" type="number" readonly class="text-center-input disable2-input" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ target_sales_thu }}</div>
                                                    <v-text-field v-else v-model="target_sales_thu" type="number" readonly class="text-center-input disable2-input" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ target_sales_fri }}</div>
                                                    <v-text-field v-else v-model="target_sales_fri" type="number" readonly class="text-center-input disable2-input" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ target_sales_sat }}</div>
                                                    <v-text-field v-else v-model="target_sales_sat" type="number" readonly class="text-center-input disable2-input" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </th>
                                                
                                                <th class="spreadsheet-cell"></th>
                                            </tr>

                                            <tr>
                                                <th class="header-cell" colspan="2">Jadwal Kirim</th>

                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ jadwalKirim[0].sales_target }}</div>
                                                    <v-text-field v-else v-model="jadwalKirim[0].sales_target" class="text-center-input jadwal_kirim-input" type="number" readonly solo hide-details />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ jadwalKirim[1].sales_target }}</div>
                                                    <v-text-field v-else v-model="jadwalKirim[1].sales_target" class="text-center-input jadwal_kirim-input" type="number" readonly solo hide-details />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ jadwalKirim[2].sales_target }}</div>
                                                    <v-text-field v-else v-model="jadwalKirim[2].sales_target" class="text-center-input jadwal_kirim-input" type="number" readonly solo hide-details />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ jadwalKirim[3].sales_target }}</div>
                                                    <v-text-field v-else v-model="jadwalKirim[3].sales_target" class="text-center-input jadwal_kirim-input" type="number" readonly solo hide-details />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ jadwalKirim[4].sales_target }}</div>
                                                    <v-text-field v-else v-model="jadwalKirim[4].sales_target" class="text-center-input jadwal_kirim-input" type="number" readonly solo hide-details />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ jadwalKirim[5].sales_target }}</div>
                                                    <v-text-field v-else v-model="jadwalKirim[5].sales_target" class="text-center-input jadwal_kirim-input" type="number" readonly solo hide-details />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ jadwalKirim[6].sales_target }}</div>
                                                    <v-text-field v-else v-model="jadwalKirim[6].sales_target" class="text-center-input jadwal_kirim-input" type="number" readonly solo hide-details />
                                                </th>

                                                <th class="header-cell"></th>
                                            </tr>

                                            <tr>
                                                <th class="header-cell" colspan="2">Total PO</th>

                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ totalQtyPerDayHeader(1) }}</div>
                                                    <v-text-field v-else class="text-center-input disable2-input" type="number" readonly solo hide-details :value="totalQtyPerDayHeader(1)" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ totalQtyPerDayHeader(2) }}</div>
                                                    <v-text-field v-else class="text-center-input disable2-input" type="number" readonly solo hide-details :value="totalQtyPerDayHeader(2)" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ totalQtyPerDayHeader(3) }}</div>
                                                    <v-text-field v-else class="text-center-input disable2-input" type="number" readonly solo hide-details :value="totalQtyPerDayHeader(3)" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ totalQtyPerDayHeader(4) }}</div>
                                                    <v-text-field v-else class="text-center-input disable2-input" type="number" readonly solo hide-details :value="totalQtyPerDayHeader(4)" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ totalQtyPerDayHeader(5) }}</div>
                                                    <v-text-field v-else class="text-center-input disable2-input" type="number" readonly solo hide-details :value="totalQtyPerDayHeader(5)" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ totalQtyPerDayHeader(6) }}</div>
                                                    <v-text-field v-else class="text-center-input disable2-input" type="number" readonly solo hide-details :value="totalQtyPerDayHeader(6)" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ totalQtyPerDayHeader(7) }}</div>
                                                    <v-text-field v-else class="text-center-input disable2-input" type="number" readonly solo hide-details :value="totalQtyPerDayHeader(7)" />
                                                </th>
                                                <th class="header-cell"></th>
                                            </tr>
                                            
                                            <tr>
                                                <th class="header-cell">Kode</th>
                                                <th class="header-cell">Produk</th>
                                                <th v-for="(item, idx) in defaultDays" :key="idx" class="header-cell text-center">
                                                    <span>
                                                    {{ item.value }}, {{ weekDates.length > 0 ? weekDates[idx].format : '' }}
                                                    </span>
                                                    <a 
                                                    v-if="!isReadonly && weekDates[idx] && weekDates[idx].is_exist"
                                                    class="link-custom"
                                                    href="javascript:void(0);" 
                                                    @click="openDetailDialog(weekDates[idx].format)">
                                                    Additional
                                                    </a>
                                                </th>
                                                <th class="header-cell text-center">Total Qty</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="isLoadData">
                                                <tr v-for="n in 4" :key="n">
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                </tr>
                                            </template>
                                            <tr v-for="(product, idp) in filteredPOProducts" :key="product.product_code">
                                                <td class="header-cell text-no-wrap">{{ idp + 1 }}.  {{ product.product_code }}</td>
                                                <td class="header-cell text-no-wrap">{{ product.product_name }}</td>

                                                <td class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ product.day_1 }}</div>
                                                    <v-text-field v-else v-model="product.day_1" type="number" :readonly="isPrevDate(0)" :class="{'spreadsheet-input': !isPrevDate(0), 'disable-input': isPrevDate(0) }" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" />
                                                </td>
                                                <td class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ product.day_2 }}</div>
                                                    <v-text-field v-else v-model="product.day_2" type="number" :readonly="isPrevDate(1)" :class="{'spreadsheet-input': !isPrevDate(1), 'disable-input': isPrevDate(1) }" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" />
                                                </td>
                                                <td class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ product.day_3 }}</div>
                                                    <v-text-field v-else v-model="product.day_3" type="number" :readonly="isPrevDate(2)" :class="{'spreadsheet-input': !isPrevDate(2), 'disable-input': isPrevDate(2) }" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" />
                                                </td>
                                                <td class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ product.day_4 }}</div>
                                                    <v-text-field v-else v-model="product.day_4" type="number" :readonly="isPrevDate(3)" :class="{'text-input': !isPrevDate(3), 'disable-input': isPrevDate(3) }" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" />
                                                </td>
                                                <td class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ product.day_5 }}</div>
                                                    <v-text-field v-else v-model="product.day_5" type="number" :readonly="isPrevDate(4)" :class="{'text-input': !isPrevDate(4), 'disable-input': isPrevDate(4) }" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" />
                                                </td>
                                                <td class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ product.day_6 }}</div>
                                                    <v-text-field v-else v-model="product.day_6" type="number" :readonly="isPrevDate(5)" :class="{'text-input': !isPrevDate(5), 'disable-input': isPrevDate(5) }" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" />
                                                </td>
                                                <td class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ product.day_7 }}</div>
                                                    <v-text-field v-else v-model="product.day_7" type="number" :readonly="isPrevDate(6)" :class="{'text-input': !isPrevDate(6), 'disable-input': isPrevDate(6) }" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" />
                                                </td>
                                                
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ totalQtyProduct(product) }}</div>
                                                    <v-text-field v-else :value="totalQtyProduct(product)" type="number" readonly class="text-center-input disable2-input" solo hide-details />
                                                </th>
                                            </tr>
                                            
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th class="header-cell"></th>
                                                <th class="header-cell"></th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ totalQtyPerDay(1) }}</div>
                                                    <v-text-field v-else :value="totalQtyPerDay(1)" type="number" readonly class="text-center-input disable2-input" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ totalQtyPerDay(2) }}</div>
                                                    <v-text-field v-else :value="totalQtyPerDay(2)" type="number" readonly class="text-center-input disable2-input" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ totalQtyPerDay(3) }}</div>
                                                    <v-text-field v-else :value="totalQtyPerDay(3)" type="number" readonly class="text-center-input disable2-input" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ totalQtyPerDay(4) }}</div>
                                                    <v-text-field v-else :value="totalQtyPerDay(4)" type="number" readonly class="text-center-input disable2-input" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ totalQtyPerDay(5) }}</div>
                                                    <v-text-field v-else :value="totalQtyPerDay(5)" type="number" readonly class="text-center-input disable2-input" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ totalQtyPerDay(6) }}</div>
                                                    <v-text-field v-else :value="totalQtyPerDay(6)" type="number" readonly class="text-center-input disable2-input" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ totalQtyPerDay(7) }}</div>
                                                    <v-text-field v-else :value="totalQtyPerDay(7)" type="number" readonly class="text-center-input disable2-input" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </th>
                                                <th class="spreadsheet-cell">
                                                    <div v-if="isReadonly" class="cell-text">{{ totalQtyPO }}</div>
                                                    <v-text-field v-else :value="totalQtyPO" type="number" readonly class="text-center-input disable2-input" solo hide-details />
                                                </th>
                                            </tr>
                                        </tfoot>
                                    </template>
                                </v-simple-table>
                                <!-- Komponen detail yang terpisah -->
                                <template>
                                    <AdditionalDetailDialog
                                        v-if="!isReadonly"
                                        :dialog.sync="showDetailDialog"
                                        :outletcode="outlet.code"
                                        :selectedDate="selectedDetailDate"
                                    />
                                </template>
                            </v-card>

                            <v-simple-table class="mt-3">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="header-cell"></th>
                                            <th v-for="(item, idx) in defaultDays" :key="idx" class="header-cell text-center">
                                                <span>
                                                {{ item.value }}, {{ weekDates.length > 0 ? weekDates[idx].format : '' }}
                                                </span>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th class="header-cell">Total PO</th>
                                            <th class="spreadsheet-cell" v-for="(item, i) in [1,2,3,4,5,6,7]" :key="i">
                                                <div v-if="isReadonly" class="cell-text">{{ totalQtyPerDay(item) }}</div>
                                                <v-text-field v-else :value="totalQtyPerDay(item)" type="number" readonly class="text-center-input disable2-input" solo hide-details @wheel="$event.target.blur()" min="0" />
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(category, i) in productCategories" :key="i">
                                            <td class="header-cell">{{ category.name }}</td>
                                            <td class="header-cell text-center" v-for="(day, i) in [1,2,3,4,5,6,7]" :key="i">
                                                {{ calculateCategorySummary(category, day) }} %
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th class="header-cell"></th>
                                            <td class="header-cell text-center font-weight-bold	" v-for="(day, i) in [1,2,3,4,5,6,7]" :key="i">
                                                {{ calculateTotalCategorySummary(day) }} %
                                            </td>
                                        </tr>
                                    </tfoot>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions class="pr-4 mt-3 mx-5">
                    <v-spacer />
                    <v-btn v-if="!isReadonly" depressed color="primary" @click="savePO">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <v-overlay :value="saveProgress" z-index="999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-dialog v-model="showDialogConfirm" max-width="400px">
        <v-card>
            <v-card-title class="headline">Success</v-card-title>
            <v-card-text>
                Your data has been saved successfully.
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="showDialogConfirm = false">OK</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>        

    </div>
</template>

<script>
import AdditionalAddDialog from '../components/AdditionalAddDialog.vue';
import AdditionalDetailDialog from '../components/AdditionalDetailDialog.vue';

export default {
    components: { AdditionalAddDialog,AdditionalDetailDialog },
    data() {
        return {
            showDialog: false,
            showDetailDialog: false,
            selectedDetailDate: null,
            saveProgress: false,
            isLoadData: false,
            selectedDate: '',
            minDate: new Date().toISOString().substring(0, 10),
            dateStart: '',
            dateEnd: '',
            valid: true,
            menuDate: false,
            editedIndex: -1,
            delivery_schedules: [
                { key: 1, value: 'Sunday' },
                { key: 2, value: 'Monday' },
                { key: 3, value: 'Tuesday' },
                { key: 4, value: 'Wednesday' },
                { key: 5, value: 'Thursday' },
                { key: 6, value: 'Friday' },
                { key: 7, value: 'Saturday' },
            ],
            target_sales_sun: 0,
            target_sales_mon: 0,
            target_sales_tue: 0,
            target_sales_wed: 0,
            target_sales_thu: 0,
            target_sales_fri: 0,
            target_sales_sat: 0,
            outlet_target_sales_sun: 0,
            outlet_target_sales_mon: 0,
            outlet_target_sales_tue: 0,
            outlet_target_sales_wed: 0,
            outlet_target_sales_thu: 0,
            outlet_target_sales_fri: 0,
            outlet_target_sales_sat: 0,
            filterBotol: '',
            outlet: {},
            weekDates: [],
            numberRule: val => {
                if (val < 0) return 'Tidak boleh kurang dari 0'
                return true
            },
            po: [],
            products:[],
            selectedBotol: [],
            botols: [],
            filteredBotols: [],
            targetDetailPlannings: [],
            jadwalKirim: [
                {id: 1, is_day: 0, sales_target: 0, target: 0},
                {id: 2, is_day: 0, sales_target: 0, target: 0},
                {id: 3, is_day: 0, sales_target: 0, target: 0},
                {id: 4, is_day: 0, sales_target: 0, target: 0},
                {id: 5, is_day: 0, sales_target: 0, target: 0},
                {id: 6, is_day: 0, sales_target: 0, target: 0},
                {id: 7, is_day: 0, sales_target: 0, target: 0},
            ],
            is_exist_po: false,
            productCategories: [],
            showDialogConfirm: false,
        }
    },
    
    computed: {
        isReadonly() {
            return this.$route.path.startsWith('/po/view/');
        },
        defaultDays() {
            return this.$store.state.outlet.default_days;
        },
        selectedBotolLabel() {
            const found = (this.filteredBotols || []).find(b => b.code === this.filterBotol);
            return found ? found.description : (this.filterBotol || '');
        },
        formattedSelectedDateRange() {
            return `${this.dateStart} - ${this.dateEnd}`
        },
        formTitle() {
            return 'Summary Purchase Order'
        },
        filteredSalesTargets() {
            if (!this.isObjectEmpty(this.outlet)) {
                return this.outlet.sales_targets.filter(i => i.size === this.filterBotol);
            } else {
                return [];
            }
        },
        filteredPOProducts() {
            if (!this.isObjectEmpty(this.outlet)) {
                return this.po.filter(i => i.product_size === this.filterBotol)
                    .sort((a, b) => a.sort_no - b.sort_no)
            } else {
                return [];
            }
        },
        deliveryScheduleDays() {
            if (!this.isObjectEmpty(this.outlet)) {
                return this.defaultDays
                    .filter(schedule => this.outlet.delivery_schedules.includes(schedule.key))
                    .map(schedule => schedule.value)
                    .join(', ')

            } else {
                return ''
            }
        },
        totalQtyProduct() {
            return (item) => {
                return Number(item.day_1) + Number(item.day_2) 
                    + Number(item.day_3) + Number(item.day_4) + Number(item.day_5) 
                    + Number(item.day_6) + Number(item.day_7);
            }
        },
        totalQtyPerDay() {
            return (day) => {
                switch (day) {
                    case 1:
                        return this.filteredPOProducts.reduce((total, item) => total + Number(item.day_1), 0)
                    case 2:
                        return this.filteredPOProducts.reduce((total, item) => total + Number(item.day_2), 0)
                    case 3:
                        return this.filteredPOProducts.reduce((total, item) => total + Number(item.day_3), 0)
                    case 4:
                        return this.filteredPOProducts.reduce((total, item) => total + Number(item.day_4), 0)
                    case 5:
                        return this.filteredPOProducts.reduce((total, item) => total + Number(item.day_5), 0)
                    case 6:
                        return this.filteredPOProducts.reduce((total, item) => total + Number(item.day_6), 0)
                    case 7:
                        return this.filteredPOProducts.reduce((total, item) => total + Number(item.day_7), 0)
                    
                    default:
                        return '';
                }
            }
        },
        totalQtyPO() {
            return Array.from({ length: 7 }, (_, i) => this.totalQtyPerDay(i + 1))
                .reduce((sum, qty) => sum + qty, 0);
        },
        totalQtyPerDayHeader() {
            return (day) => {
                if (day < 1 || day > 7) return 0;

                if (this.is_exist_po) {
                    const field = `day_${day}`;
                    return this.filteredPOProducts.reduce((total, item) => total + Number(item[field] || 0), 0);
                } else {
                    const targets = {
                        1: this.target_sales_sun,
                        2: this.target_sales_mon,
                        3: this.target_sales_tue,
                        4: this.target_sales_wed,
                        5: this.target_sales_thu,
                        6: this.target_sales_fri,
                        7: this.target_sales_sat
                    };
                    if (this.jadwalKirim[day -1].sales_target > 0) {
                        return targets[day] || 0;
                    } else {
                        return 0;
                    }
                }
            };
        }
    },
    watch: {

    },
    async mounted() {
        this.loadPO();

        // await this.checkExistDates();

        this.getProductCategories();
    },
    async created() {
        this.getBotols();
        this.getDataProducts();

        const outlet_code = this.$route.params.outlet_code
        if (outlet_code != '') {
            this.loadOutlet(outlet_code);
            this.selectedDate = new Date().toISOString().split('T')[0];
            this.setWeekRange(this.selectedDate);
        }
    },
    methods: {
        async checkExistDates() {
            const updatedWeekDates = await Promise.all(
                this.weekDates.map(async (dateObj) => {
                try {
                    const res = await this.$store.dispatch('po/getDetailPOAdditional', {
                    outletcode: this.$route.params.outlet_code,
                    date: dateObj.format
                    });

                    // Cek apakah status-nya 'success'
                    dateObj.is_exist = res.data?.status === 'success' &&
                           Array.isArray(res.data?.data?.products) &&
                           res.data.data.products.length > 0;
                } catch (err) {
                    dateObj.is_exist = false;
                }

                return dateObj;
                })
            );

            this.weekDates = updatedWeekDates;
        },
        getBotols() {
            let dataMiscCodes = this.$store.state.misccode.objs
            this.botols = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                })
        },
        filterBotols() {
            if (this.selectedBotol.length === 0) {
                this.filteredBotols = this.botols
            } else {
                this.filteredBotols = this.botols.filter(item => this.selectedBotol.includes(item.code))
            }

            let firstBotol = this.filteredBotols.slice(0, 1)[0];
            this.filterBotol = firstBotol.code
        },
        async loadOutlet(code) {
            const data = (await this.$store.dispatch('outlet/getObj', code))
            this.outlet = data
            this.selectedBotol = this.outlet.botols
            this.filterBotols()

            this.loadPO();
        },
        isObjectEmpty(obj) {
            return Object.keys(obj).length === 0
        },
        async handleDateChange(value) {
            this.selectedDate = value
            this.setWeekRange(value)
            this.menuDate = false

            if (this.outlet) {
                this.loadPO();
            }
        },
        setWeekRange(date) {
            const selected = new Date(date)

            const dayOfWeek = selected.getDay() // 0 - 6
            const firstDay = new Date(selected)
            firstDay.setHours(0,0,0,0)
            firstDay.setDate(selected.getDate() - dayOfWeek)

            const lastDay = new Date(firstDay)
            lastDay.setDate(firstDay.getDate() + 6)

            this.dateStart = this.formatDate(this.formatLocalDate(firstDay))
            this.dateEnd   = this.formatDate(this.formatLocalDate(lastDay))

            this.generateDates(firstDay)
        },
        generateDates(startDate) {
            const dates = []
            const currentDate = new Date(startDate)

            for (let i = 0; i < 7; i++) {
                const dateStr = this.formatLocalDate(currentDate)

                dates.push({
                    date: dateStr,
                    format: this.formatDate(dateStr),
                    is_exist: false
                })

                currentDate.setDate(currentDate.getDate() + 1)
            }

            this.weekDates = dates
        },
        formatLocalDate(date) {
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            return `${y}-${m}-${d}`
        },
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        async loadPO() {
            try {
                this.isLoadData = true
                
                const outlet_code = this.$route.params.outlet_code

                const start = this.weekDates.length > 0 ? this.weekDates[0].date : ''
                const end = this.weekDates.length > 0 ? this.weekDates[6].date : ''
                
                const dataPO = (await this.$store.dispatch('po/getObjs', { 
                    outlet_code: outlet_code,
                    start_date : start, 
                    end_date: end,
                    size: this.filterBotol,
                }));

                this.is_exist_po = dataPO.is_exist_po;

                if (dataPO.data.length > 0) {
                    this.po = dataPO.data
                } else {
                    if (this.outlet && this.outlet.sales_targets && Array.isArray(this.outlet.sales_targets)) {
                        this.po = this.outlet.sales_targets.map(item => ({
                            product_code: item.code,
                            product_name: item.name,
                            product_size: item.size,
                            day_1: null,
                            day_2: null,
                            day_3: null,
                            day_4: null,
                            day_5: null,
                            day_6: null,
                            day_7: null,
                            dayx_1: 0,
                            dayx_2: 0,
                            dayx_3: 0,
                            dayx_4: 0,
                            dayx_5: 0,
                            dayx_6: 0,
                            dayx_7: 0,
                        }));
                    } else {
                        console.log('po tidka ada');
                    }
                }

                this.targetDetailPlannings = dataPO.detail_plannings;

                if (dataPO.targets && Array.isArray(dataPO.targets)) {
                    if (dataPO.targets.length > 0) {
                        this.getTargets(dataPO.targets)
                    } else {
                        this.getTargets(this.outlet.targets)
                    }
                } else {
                    if (this.outlet.targets.length > 0) {
                        this.getTargets(this.outlet.targets)
                    }
                }

                this.getOutletTargets();
                this.checkIsDay();

                this.calculateAllJadwalKirim();
                this.calculateEachProductOutlet();

            } catch (error) {
                console.log('Error loading data:', error)
            } finally {
                this.isLoadData = false
            }
        },
        calculateTotalQty(day) {
            switch (day) {
                    case 1:
                        return this.filteredPOProducts.reduce((total, item) => total + Number(item.day_1), 0)
                    case 2:
                        return this.filteredPOProducts.reduce((total, item) => total + Number(item.day_2), 0)
                    case 3:
                        return this.filteredPOProducts.reduce((total, item) => total + Number(item.day_3), 0)
                    case 4:
                        return this.filteredPOProducts.reduce((total, item) => total + Number(item.day_4), 0)
                    case 5:
                        return this.filteredPOProducts.reduce((total, item) => total + Number(item.day_5), 0)
                    case 6:
                        return this.filteredPOProducts.reduce((total, item) => total + Number(item.day_6), 0)
                    case 7:
                        return this.filteredPOProducts.reduce((total, item) => total + Number(item.day_7), 0)
                    
                    default:
                        return 0;
                }
        },
        onBotolChange(value) {
            this.loadPO();
            if (this.filteredPOProducts.length == 0) {
                let dataProduct = this.products.filter(p => p.size === value)
                dataProduct.forEach((item) => {
                    let prodPO = {
                        product_code: item.code,
                        product_name: item.name,
                        product_size: item.size,
                        day_1: 0,
                        day_2: 0,
                        day_3: 0,
                        day_4: 0,
                        day_5: 0,
                        day_6: 0,
                        day_7: 0,
                        dayx_1: 0,
                        dayx_2: 0,
                        dayx_3: 0,
                        dayx_4: 0,
                        dayx_5: 0,
                        dayx_6: 0,
                        dayx_7: 0,
                    }
                    if (!this.po.some(p => p.product_code === prodPO.product_code)) {
                        this.po.push(prodPO)
                    }
                });
            }

            this.calculateEachProductOutlet();
        },
        calculateQtyItemProduct(day, product, isOutlet = false) {
            let result = 0;

            let totalPercentageProduct = this.getTotalPercentageFromSalesTarget(day); // 00; //this.calculateTotalQty(day)
            let percentageTarget = 0;
            let qtySalesTarget = 0;

            let dataSalesTarget = this.filteredSalesTargets.find(i => i.code == product.product_code);

            switch (day) {
                case 1:
                    if (product.day_1 == null) {
                        qtySalesTarget = isOutlet ? this.jadwalKirim[0].target : this.jadwalKirim[0].sales_target;
    
                        percentageTarget = dataSalesTarget ? dataSalesTarget.target_sun : 0;
                        result = this.calculateQtyProduct(percentageTarget, totalPercentageProduct, qtySalesTarget);
                    } else {
                        result = product.day_1;
                    }

                    break;                    
                case 2:
                    if (product.day_2 == null) {
                        qtySalesTarget = isOutlet ? this.jadwalKirim[1].target : this.jadwalKirim[1].sales_target;
                        percentageTarget = dataSalesTarget ? dataSalesTarget.target_mon : 0;
                        result = this.calculateQtyProduct(percentageTarget, totalPercentageProduct, qtySalesTarget);
                    } else {
                        result = product.day_2;
                    }

                    break;
                case 3:
                    if (product.day_3 == null) {
                        qtySalesTarget = isOutlet ? this.jadwalKirim[2].target : this.jadwalKirim[2].sales_target;
                        percentageTarget = dataSalesTarget ? dataSalesTarget.target_tue : 0;
                        result = this.calculateQtyProduct(percentageTarget, totalPercentageProduct, qtySalesTarget);
                    } else {
                        result = product.day_3;
                    }

                    break;
                case 4:
                    if (product.day_4 == null) {
                        qtySalesTarget = isOutlet ? this.jadwalKirim[3].target : this.jadwalKirim[3].sales_target;
                        percentageTarget = dataSalesTarget ? dataSalesTarget.target_wed : 0;
                        result = this.calculateQtyProduct(percentageTarget, totalPercentageProduct, qtySalesTarget);
                    } else {
                        result = product.day_4;
                    }

                    break;
                case 5:
                    if (product.day_5 == null) {
                        qtySalesTarget = isOutlet ? this.jadwalKirim[4].target : this.jadwalKirim[4].sales_target;
                        percentageTarget = dataSalesTarget ? dataSalesTarget.target_thu : 0;
                        result = this.calculateQtyProduct(percentageTarget, totalPercentageProduct, qtySalesTarget);
                    } else {
                        result = product.day_5;
                    }

                    break;
                case 6:
                    if (product.day_6 == null) {
                        qtySalesTarget = isOutlet ? this.jadwalKirim[5].target : this.jadwalKirim[5].sales_target;
                        percentageTarget = dataSalesTarget ? dataSalesTarget.target_fri : 0;
                        result = this.calculateQtyProduct(percentageTarget, totalPercentageProduct, qtySalesTarget);
                    } else {
                        result = product.day_6;
                    }
                    
                    break;
                case 7:
                    if (product.day_7 == null) {
                        qtySalesTarget = isOutlet ? this.jadwalKirim[6].target : this.jadwalKirim[6].sales_target;
                        percentageTarget = dataSalesTarget ? dataSalesTarget.target_sat : 0;
                        result = this.calculateQtyProduct(percentageTarget, totalPercentageProduct, qtySalesTarget);
                    } else {
                        result = product.day_7;
                    }                    

                    break;
                default:
                    
                    break;
            }

            return result;
        },
        calculateEachProductOutlet() {
            this.po = this.po.map(item => ({
                ...item,
                day_1: this.calculateQtyItemProduct(1, item),
                day_2: this.calculateQtyItemProduct(2, item),
                day_3: this.calculateQtyItemProduct(3, item),
                day_4: this.calculateQtyItemProduct(4, item),
                day_5: this.calculateQtyItemProduct(5, item),
                day_6: this.calculateQtyItemProduct(6, item),
                day_7: this.calculateQtyItemProduct(7, item),
            }));
        },
        calculateQtyProduct(percentageTarget, totalPercentageProduct, qtySalesTarget) {
            let result = 0;

            if (totalPercentageProduct > 0 && qtySalesTarget > 0) {
                result = (percentageTarget / totalPercentageProduct) * qtySalesTarget;
                result = Math.round(result);
            }

            return result;
        },
        getTotalPercentageFromSalesTarget(day) {
            let result = 0

            if (day == 1) {
                const totalTarget = this.outlet.sales_targets.filter(item => item.size === this.filterBotol)
                    .reduce((sum, item) => sum + item.target_sun, 0)

                result = totalTarget
            }
            if (day == 2) {
                const totalTarget = this.outlet.sales_targets.filter(item => item.size === this.filterBotol)
                    .reduce((sum, item) => sum + item.target_mon, 0)

                result = totalTarget
            }
            if (day == 3) {
                const totalTarget = this.outlet.sales_targets.filter(item => item.size === this.filterBotol)
                    .reduce((sum, item) => sum + item.target_tue, 0)

                result = totalTarget
            }
            if (day == 4) {
                const totalTarget = this.outlet.sales_targets.filter(item => item.size === this.filterBotol)
                    .reduce((sum, item) => sum + item.target_wed, 0)

                result = totalTarget
            }
            if (day == 5) {
                const totalTarget = this.outlet.sales_targets.filter(item => item.size === this.filterBotol)
                    .reduce((sum, item) => sum + item.target_thu, 0)

                result = totalTarget
            }
            if (day == 6) {
                const totalTarget = this.outlet.sales_targets.filter(item => item.size === this.filterBotol)
                    .reduce((sum, item) => sum + item.target_fri, 0)

                result = totalTarget
            }
            if (day == 7) {
                const totalTarget = this.outlet.sales_targets.filter(item => item.size === this.filterBotol)
                    .reduce((sum, item) => sum + item.target_sat, 0)

                result = totalTarget
            }

            return result
        },
        convertDataForServer() {
            let dataOrder = []

            let delivery_day = {};
            let arrival_day = {};

            for (let i = 0; i < this.outlet.delivery_schedules.length; i++) {
                delivery_day[this.outlet.delivery_schedules[i]] = this.outlet.delivery_schedules2[i];
                arrival_day[this.outlet.delivery_schedules[i]] = this.outlet.arrive_schedules[i];
            }

            this.weekDates.forEach((weekdate, weekdateIndex) => {
                this.po.forEach((itemPo) => {
                    let quantityOrdered = 0

                    switch (weekdateIndex) {
                        case 0:
                            quantityOrdered = itemPo.day_1
                            break;
                        case 1:
                            quantityOrdered = itemPo.day_2
                            break;
                        case 2:
                            quantityOrdered = itemPo.day_3
                            break;
                        case 3:
                            quantityOrdered = itemPo.day_4
                            break;
                        case 4:
                            quantityOrdered = itemPo.day_5
                            break;
                        case 5:
                            quantityOrdered = itemPo.day_6
                            break;
                        case 6:
                            quantityOrdered = itemPo.day_7
                            break;
                    
                        default:
                            break;
                    }
                    let delivery_date2 = weekdate.date
                    let arrival_date = weekdate.date
                    if (delivery_day[weekdateIndex + 1] !== 0 && delivery_day[weekdateIndex + 1] !== undefined) {
                        const newDate = new Date(weekdate.date);
                        const newDate2 = new Date(weekdate.date);
                        newDate.setDate(newDate.getDate() + delivery_day[weekdateIndex + 1]);
                        newDate2.setDate(newDate.getDate() + arrival_day[weekdateIndex + 1]);
                        delivery_date2 = newDate.toISOString().split('T')[0];
                        arrival_date = newDate2.toISOString().split('T')[0];
                    }

                    dataOrder.push({
                        outlet_code: this.outlet.code,
                        product_code: itemPo.product_code,
                        product_size: itemPo.product_size,
                        delivery_date: weekdate.date,
                        delivery_date2: delivery_date2,
                        arrival_date: arrival_date,
                        quantity_ordered: quantityOrdered,
                    })
                })
            })

            return dataOrder
        },
        async savePO() {
            if (this.isReadonly) return;
            await this.$refs.poform.validate();

            if (!this.valid) return;

            this.saveProgress = true;

            let dataOrder = this.convertDataForServer()

            const result = await this.$store.dispatch('po/postObj', {orders: dataOrder})

            if (result.status == 200 || result.status == 201) {
                // this.backToPO();
                this.saved = true
            } else {
                this.saveError = true
            }

            this.saveProgress = false
            this.showDialogConfirm = true;
        },
        isPrevDate(day) {
            const dateStr = this.weekDates.length > 0 ? this.weekDates[day].date : ''
            const today = new Date().setHours(0, 0, 0, 0)
            const selected = new Date(dateStr).setHours(0, 0, 0, 0)
            return selected < today
        },
        async getDataProducts() {
            let response = await this.$store.dispatch('variant/getObjs')
            if (response.data.status == 'success') {
                this.products = response.data.data;
            }
        },
        getTargets(items) {
            if (items) {
                if (items.length > 0) {
                    const filtered = items.find(item => item.size === this.filterBotol);
                    const days = [
                        'target_sales_sun',
                        'target_sales_mon',
                        'target_sales_tue',
                        'target_sales_wed',
                        'target_sales_thu',
                        'target_sales_fri',
                        'target_sales_sat',
                    ];
    
                    if (filtered !== undefined) {
                        days.forEach((day, index) => {
                            if (filtered.days[index] !== undefined) {
                                let targetSales = this.getTargetSalesPlanning(index);
                                // if (targetSales == 0) {
                                //     targetSales = parseInt(filtered.days[index]);
                                // }
                                // console.log(`day:${day}, targetSales:${targetSales}`);
                                this[day] = targetSales;
                            } else {
                                console.error(`Data for ${day} is undefined`);
                            }
                        });
                    }
                }
            }
        },
        getOutletTargets() {
            if (this.outlet.targets) {
                if (this.outlet.targets.length > 0) {
                    const filtered = this.outlet.targets.find(item => item.size === this.filterBotol);
                    const days = [
                        'outlet_target_sales_sun',
                        'outlet_target_sales_mon',
                        'outlet_target_sales_tue',
                        'outlet_target_sales_wed',
                        'outlet_target_sales_thu',
                        'outlet_target_sales_fri',
                        'outlet_target_sales_sat',
                    ];

                    if (filtered !== undefined) {
                        days.forEach((day, index) => {
                            if (filtered.days[index] !== undefined) {
                                this[day] = parseInt(filtered.days[index]);
                            } else {
                                console.error(`Data for ${day} is undefined`);
                            }
                        });
                    }
    
                }
            }
        },
        getTargetSalesPlanning(day) {
            const weekDate = this.weekDates[day];
            if (weekDate) {
                const date = weekDate.date;
                const data = this.targetDetailPlannings.find((i) => i.volume == this.filterBotol && i.sales_date == date);
                if (data) {
                    return data.sales_target;
                } else {
                    return 0;
                }
            } else {
                return 0;
            }
        },
        calculateQtyJadwalKirim(row, isOutlet = false) {
            let result = 0;
            const filters = this.jadwalKirim.filter(i => i.id >= row.id);

            if (row.is_day) {
                for (const rowFilter of filters) {
                    if (rowFilter.id !== row.id && rowFilter.is_day) {
                        break;
                    }
                    result += isOutlet ? parseInt(this.getOutletTargetDay(rowFilter.id)) : parseInt(this.getTargetDay(rowFilter.id));
                }
                if (row.id == this.lastDeliveryScheduleDay()) {
                    const nextFilters = this.jadwalKirim.filter(i => i.id <= row.id);
                    for (const rowFilter of nextFilters) {
                        if (rowFilter.is_day) {
                            break;
                        }
                        result += isOutlet ? parseInt(this.getOutletTargetDay(rowFilter.id)) : parseInt(this.getTargetDay(rowFilter.id));
                    }
                }
            }

            return result;
        },
        checkIsDay() {
            if (this.outlet && Array.isArray(this.outlet.delivery_schedules)) {
                this.jadwalKirim = this.jadwalKirim.map((item) => ({
                    ...item,
                    is_day: this.outlet.delivery_schedules.includes(item.id),
                }));
            }
        },
        calculateAllJadwalKirim() {
            this.jadwalKirim = this.jadwalKirim.map((item) => ({
                ...item,
                sales_target: this.calculateQtyJadwalKirim(item),
                target: this.calculateQtyJadwalKirim(item, true),
            }));
        },
        lastDeliveryScheduleDay() {
            return this.outlet.delivery_schedules.length > 0 ? this.outlet.delivery_schedules[this.outlet.delivery_schedules.length - 1] : null;
        },
        getTargetDay(day) {
            switch (day) {
                case 1:
                    return this.target_sales_sun;
                case 2:
                    return this.target_sales_mon;
                case 3:
                    return this.target_sales_tue;
                case 4:
                    return this.target_sales_wed;
                case 5:
                    return this.target_sales_thu;
                case 6:
                    return this.target_sales_fri;
                case 7:
                    return this.target_sales_sat;
                default:
                    break;
            }
        },
        getOutletTargetDay(day) {
            switch (day) {
                case 1:
                    return this.outlet_target_sales_sun;
                case 2:
                    return this.outlet_target_sales_mon;
                case 3:
                    return this.outlet_target_sales_tue;
                case 4:
                    return this.outlet_target_sales_wed;
                case 5:
                    return this.outlet_target_sales_thu;
                case 6:
                    return this.outlet_target_sales_fri;
                case 7:
                    return this.outlet_target_sales_sat;
                default:
                    break;
            }
        },
        async handleSaveAdditional(data) {
            if (this.isReadonly) return;
            // console.log('Data disimpan:', data);
            this.saveProgress = true;

            try {
            const result = await this.$store.dispatch('po/postObjAdditional', data);
                if (result.data.status != 'error') {
                    this.loadPO();
                    // this.checkExistDates();
                    this.saved = true;
                    this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: result.data.message});
                } else {
                    this.saveError = true;
                    this.$store.commit('setSnackbar', {saveError: true, errorMessage: result.data.message})
                }
            } catch (error) {
                this.saveError = true;
                this.$store.commit('setSnackbar', {saveError: true, errorMessage: 'Terjadi kesalahan saat menyimpan data.'})
            } finally {
                this.saveProgress = false;
            }
        },
        openDetailDialog(date) {
            if (this.isReadonly) return;
            this.selectedDetailDate = date;
            this.showDetailDialog = true;
        },
        async getProductCategories() {
            let response = await this.$store.dispatch('productcategory/getObjs');
            if (response.data.status == 'success') {
                this.productCategories = response.data.data;
            }
        },
        calculateCategorySummary(category, day) {
            if (day < 1 || day > 7) return '';

            const key = `day_${day}`;
            const totalPerCategory = this.filteredPOProducts
                .filter(item => item.product_category_code === category.code)
                .reduce((total, item) => total + Number(item[key] || 0), 0);
            
            const totalProduct = this.filteredPOProducts
                .reduce((total, item) => total + Number(item[key] || 0), 0);

            if (!totalProduct) return 0;

            const percent = (totalPerCategory / totalProduct) * 100;

            return Math.ceil(percent);
        },
        calculateTotalCategorySummary(day) {
            const total = this.productCategories
                .reduce((total, item) => total + Number(this.calculateCategorySummary(item, day)), 0);

            return Math.ceil(total);
        },
        backToPO() {
            this.$router.push(`/po`);
        }
    }
}
</script>

<style scoped>
.readonly-field {
    border: 1px solid #ddd;
    border-radius: 7px;
    padding: 8px 12px;
    background-color: #F5F5F5;
    min-height: 40px;
    display: flex;
    align-items: center;
}

.cell-text {
    min-height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
    font-variant-numeric: tabular-nums;
}

.link-custom {
    color: #1976D2; text-decoration: underline;
}
.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
    border-radius: 7px!important;
}

.text-input input {
  padding: 0 !important;
  border: none;
  background-color: #ffe169 !important;
}

.text-input ::v-deep .v-input__control {
  background-color: #ffe169 !important;
}

.text-input ::v-deep .v-input__slot {
  background-color: #ffe169 !important;
}

.text-input ::v-deep .v-input__control input {
  background-color: #ffe169 !important;
  text-align: center;
}

.text-input .v-input__slot {
    background-color: #ffe169 !important;
    text-align: center;
}

.text-center-input .v-input__slot {
    text-align: center;
}

.text-center-input ::v-deep .v-input__control input {
  text-align: center;
}

.spreadsheet-table {
  border-collapse: collapse;
  width: 100%;
}

.header-cell,
.spreadsheet-cell {
  border: 1px solid #ddd;
  padding: 8px !important;
  text-align: left;
  min-width: 100px;
}

.spreadsheet-cell {
  background-color: #f9f9f9;
  cursor: pointer;
  padding: 0px !important;
}

.spreadsheet-cell:focus-within {
  background-color: #e6f7ff;
  outline: none;
}

.spreadsheet-input {
  padding: 0 !important;
  margin: 0;
  border: none;
  box-shadow: none;
  background-color: transparent !important;
  font-size: inherit;
  width: 100%;
}

.spreadsheet-input input {
  padding: 0 !important;
  border: none;
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__slot {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control input {
  background-color: #ffe169 !important;
  text-align: center;
}

.spreadsheet-input .v-input__slot {
    background-color: #ffe169 !important;
    text-align: center;
}

.spreadsheet-cell .v-text-field.v-text-field--solo .v-input__control input {
  text-align: center !important;
}

.disable-input input {
  padding: 0 !important;
  border: none;
  background-color: #E0E0E0 !important;
}

.disable-input ::v-deep .v-input__control {
  background-color: #E0E0E0 !important;
}

.disable-input ::v-deep .v-input__slot {
  background-color: #E0E0E0 !important;
}

.disable-input ::v-deep .v-input__control input {
  background-color: #E0E0E0 !important;
}

.disable-input .v-input__slot {
    background-color: #E0E0E0 !important;
}

.disable2-input input {
  padding: 0 !important;
  border: none;
  background-color: #F5F5F5 !important;
}

.disable2-input ::v-deep .v-input__control {
  background-color: #F5F5F5 !important;
}

.disable2-input ::v-deep .v-input__slot {
  background-color: #F5F5F5 !important;
}

.disable2-input ::v-deep .v-input__control input {
  background-color: #F5F5F5 !important;
}

.disable2-input .v-input__slot {
    background-color: #F5F5F5 !important;
}

.v-data-table table tfoot th
{
	position: sticky;
	bottom: 0;
	background: #FFF;
}

.po_total-input input {
  padding: 0 !important;
  border: none;
  background-color: #bde0fe !important;
}

.po_total-input ::v-deep .v-input__control {
  background-color: #bde0fe !important;
}

.po_total-input ::v-deep .v-input__slot {
  background-color: #bde0fe !important;
}

.po_total-input ::v-deep .v-input__control input {
  background-color: #bde0fe !important;
}

.po_total-input .v-input__slot {
    background-color: #bde0fe !important;
}

.po_total-input input {
  padding: 0 !important;
  border: none;
  background-color: #bde0fe !important;
}

.po_total-input ::v-deep .v-input__control {
  background-color: #bde0fe !important;
}

.po_total-input ::v-deep .v-input__slot {
  background-color: #bde0fe !important;
}

.po_total-input ::v-deep .v-input__control input {
  background-color: #bde0fe !important;
}

.po_total-input .v-input__slot {
    background-color: #bde0fe !important;
}

.jadwal_kirim-input input {
  padding: 0 !important;
  border: none;
  background-color: #FF7F7F !important;
}

.jadwal_kirim-input ::v-deep .v-input__control {
  background-color: #FF7F7F !important;
}

.jadwal_kirim-input ::v-deep .v-input__slot {
  background-color: #FF7F7F !important;
}

.jadwal_kirim-input ::v-deep .v-input__control input {
  background-color: #FF7F7F !important;
}

.jadwal_kirim-input .v-input__slot {
    background-color: #FF7F7F !important;
}

scrollable-tbody {
  border-collapse: collapse;
}

/* Scroll only tbody */
.scrollable-tbody >>> tbody {
  display: block;
  max-height: 300px; /* Set your scroll height */
  overflow-y: auto;
}

/* Fix the column widths and align with thead */
.scrollable-tbody >>> thead tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.scrollable-tbody >>> tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
</style>